module.exports = __webpack_public_path__ + "static/media/8.f48c4bab.jpg";